export default "__VITE_PUBLIC_ASSET__34b458fe__"